import React from "react";
import dynamic from "next/dynamic";

const ImageUI = dynamic(() => import("@/common/UI/Image"));
const IconBoxCardWithImageBelow = dynamic(() =>
  import("@/components/common/card/IconBoxCardWithImageBelow")
);

const SingleLargeIconBoxCardWithImage = (props) => {
  const { certificationsList, labelsList } = props;

  return (
    <>
      {certificationsList ? (
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-16">
          <div className="md:col-span-3">
            <IconBoxCardWithImageBelow
              // icon={temp4}
              title={certificationsList?.certificationSubtitle}
              info={certificationsList?.certificationAbstract}
              btnUrl={`/${certificationsList?.slug}`}
              btnText={labelsList?.more}
              image={certificationsList?.gallery?.[0]?.webp}
            />
          </div>
          <div className="relative flex md:flex-col self-center items-center justify-center md:justify-end">
            {certificationsList?.certificationIcons?.map((item, index) => {
              return (
                <div className="img-wrap p-2 contain-image " key={index}>
                  <ImageUI
                    src={item?.webp}
                    alt={item?.alt}
                    title={item?.title}
                    width={150}
                    height={120}
                  />
                </div>
              );
            })}
          </div>
        </div>
      ) : null}
    </>
  );
};
export default SingleLargeIconBoxCardWithImage;
